import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
    getPublicKey,
    setupOrgEncryption,
} from "~/services/gateways/orgEncryption.gateway";
import type { OrgEncryptionSetupPayload } from "~/domain/OrgEncryption";

export function useOrgPublicKey(enabled = true) {
    return useQuery({
        queryKey: ["org-encryption", "public-key"],
        queryFn: getPublicKey,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        enabled,
    });
}

export function useSetupOrgEncryption() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (payload: OrgEncryptionSetupPayload) => setupOrgEncryption(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["org-encryption", "public-key"] });
        },
    });
}
